export function pick(obj: any, keys: any) {
  return Object.entries(obj)
    .filter(([key]) => keys.includes(key))
    .reduce((_obj, [key, val]) => Object.assign(_obj, { [key]: val }), {});
}
